module.exports = __webpack_public_path__ + "static/hmd-logo-small-256-86437d226c075177aa850b59d165b181.png";